const product_status_options = [
  { label: "Aktywny", value: "active" },
  { label: "Do wyprzedania", value: "inactive" },
  { label: "Nieaktywny", value: "discontinued" },
];

export const product_status_search_options = [
  { label: "Aktywny", value: 0 },
  { label: "Do wyprzedania", value: 1 },
  { label: "Nieaktywny", value: 2 },
];

export const getStatusByValue = (val) =>
  product_status_options.find(({ value }) => value === val)?.label;

export default product_status_options;
